/* eslint-disable react/prop-types */
import { Button, Modal } from "react-bootstrap"

export const ContactGAI = ({ show, hide, selectedRow }) => {
    return (
        <Modal
            show={show}
            onHide={hide}
            size="lg"
            centered>
            <Modal.Header closeButton>
                <Modal.Title>Contact GAI</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>We look forward to working with you on your renewal!</div>
                <div>Please contact us at:</div>
                <b>
                    {selectedRow?.brokerContactFirstName + " " + selectedRow?.brokerContactLastName}, Underwriter – PCE
                    {/* TODO: Need to clear what is "Underwriter – PCE" ^, Its not available in the API response */}
                </b>
                <div>
                    M - <a href={`tel:${selectedRow?.brokerContactPhone}`}>{selectedRow?.brokerContactPhone}</a> | O -{" "}
                    <a href={`tel:${selectedRow?.brokeragePhone}`}>{selectedRow?.brokeragePhone}</a> | E -{" "}
                    <a href={`mailto:${selectedRow?.recipientEmail}`}>{selectedRow?.recipientEmail}</a>
                </div>
                <div>
                    <b>Environmental Division</b> | <a href="http://gaic.com/environmental">gaic.com/environmental</a> |
                    397 Eagleview Blvd., Suite 100 Exton, PA 19341
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={hide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
